import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "module/main/store/hooks";
import Toast from "./Toast";
import { selectToasts } from "module/main/store/toast/selectors";
import { resetToast } from "module/main/store/toast/reducer";
var ToastContainer = function () {
    var currentToasts = useAppSelector(selectToasts);
    var dispatch = useDispatch();
    var mappedToasts = currentToasts.map(function (_a) {
        var message = _a.message, id = _a.id, type = _a.type;
        return (_jsx("div", { children: _jsx(Toast, { type: type, message: message }) }, id));
    });
    // automatically clear toast array after last toast has faded away
    useEffect(function () {
        var timeout = null;
        if (mappedToasts.length) {
            timeout = setTimeout(function () { return dispatch(resetToast()); }, 5000 + 400);
        }
        return function () { return clearTimeout(timeout || undefined); };
    }, [dispatch, mappedToasts]);
    return mappedToasts.length ? mappedToasts : null;
};
export default ToastContainer;
